import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { useDispatch } from "react-redux";
import editIcon from "../../../../assets/png/edit.png";
import deleteIcon from "../../../../assets/png/delete.png";
import viewIcon from "../../../../assets/png/view.png";
import Modal from "../../../../components/modal/Modal";
import { handleGetRequest } from "../../../../services/GetTemplate";
import { handleDeleteRequest } from "../../../../services/DeleteTemplate";
import { baseURL } from "../../../../Config";
import Loading from "../../../../components/Loader";
import AddCompany from "./AddCompany";
import EditViewCompany from "./EditViewCompany";
import { useHistory } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { InputSwitch } from "primereact/inputswitch";
import { handlePutRequest } from "../../../../services/PutTemplate";
import { Dropdown } from "primereact/dropdown";
import NavigationComponent from "../../../../components/NavigationComponent";

const ManageCampany = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allMaker, setAllMaker] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentModal, setCurrentModal] = useState(null);
    const [isEditable, setIsEditAble] = useState(false);
    const [makerdataId, setMakerDataId] = useState();
    const [displayDialog, setDisplayDialog] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        representative: { value: null, matchMode: FilterMatchMode.IN },
        updatedStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
        verified: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [switchModal, setSwitchModal] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [statusValue, setStatusValue] = useState("all");
    const [filteredMakers, setFilteredMakers] = useState([]);
    const statusOptions = [
        { id: "all", name: "All" },
        { id: "active", name: "Active" },
        { id: "inactive", name: "Inactive" },
    ];

    const dispatch = useDispatch();
    const history = useHistory();

    const userIdStr = localStorage.getItem("rememberMe") === "y" ? localStorage.getItem("userDetails") : sessionStorage.getItem("userDetails");

    const userId = JSON.parse(userIdStr);
    const userRole = userId?.data?.role;

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value.replace(/^\s+/, ""));
    };

    const statusTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <InputSwitch
                    className="edit-btn ml-1 mt-2"
                    checked={rowData.isActive == "1"}
                    onChange={() => {
                        handleSwitchModalOpen();
                        setSwitchData(rowData);
                    }}
                />
            </div>
        );
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                {!userRole?.toLowerCase().includes("user") && (
                    <Button className="edit-btn ml-1 px-2" onClick={() => handleEditUsers(rowData)}>
                        <img src={editIcon} alt="Edit" />
                    </Button>
                )}
                <Button className="edit-btn ml-1 px-2" onClick={() => handleViewCampany(rowData)}>
                    <img src={viewIcon} alt="View" />
                </Button>
                {!userRole?.toLowerCase().includes("user") && (
                    <Button
                        className="edit-btn ml-1 px-2"
                        onClick={() => {
                            handleOpenModal();
                            setModalData(rowData);
                        }}
                    >
                        <img src={deleteIcon} alt="Delete" />
                    </Button>
                )}
            </div>
        );
    };

    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let newdata = {
            isActive: switchData?.isActive ? false : true,
        };

        const response = await dispatch(handlePutRequest(newdata, `/api/v1/makers/update/${switchData?.id}`, false, true));

        if (response?.status === 200) {
            getMakerList();
        }
        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };
    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const onHide = () => {
        setDisplayDialog(false);
        setCurrentModal(null);
    };

    const handleDialog = () => {
        setCurrentModal("Add");
        setDisplayDialog(true);
    };

    const handleEditUsers = (rowData) => {
        setCurrentModal("EditView");
        setDisplayDialog(true);
        setIsEditAble(true);
        setMakerDataId(rowData.id);
    };
    const handleViewCampany = (rowData) => {
        setCurrentModal("EditView");
        setDisplayDialog(true);
        setIsEditAble(false);
        setMakerDataId(rowData.id);
    };

    const getMakerList = async () => {
        setLoading(true);
        const response = await dispatch(handleGetRequest("/api/v1/makers/getAllP", false));
        if (response) {
            setAllMaker(response?.data);
        }
        setLoading(false);
    };

    useEffect(() => {
        getMakerList();
    }, []);
    useEffect(() => {
        const updatedResponse = allMaker?.filter((item) => {
            if (statusValue === "active") return item?.isActive;
            else if (statusValue === "inactive") return !item?.isActive;
            else return item;
        });
        setFilteredMakers(updatedResponse);
    }, [statusValue, allMaker]);

    const handleDeleteMaker = async () => {
        setLoadingBtn(true);

        const response = await dispatch(handleDeleteRequest(`/api/v1/makers/delete/${modalData?.id}`, true, true));
        if (response?.status === 200) {
            getMakerList();
        }
        setLoadingBtn(false);
        handleCloseModal();
    };

    const optionTemplate = (option) => {
        return <div className={option.className}>{option.name}</div>;
    };
    const selectedItemTemplate = (option) => {
        if (option) {
            return <div className={option.className}>{option.name}</div>;
        }
        return <span>Select Status</span>;
    };
    const ImageTemplate = (rowData) => {
        return (
            <React.Fragment>
                <img
                    crossorigin="anonymous"
                    src={baseURL + "/" + rowData?.logo}
                    width="70px"
                    height="45px"
                    alt="Maker's Logo"
                    style={{ borderRadius: "10px" }}
                    onError={(e) => {
                        e.target.onerror = null; // Prevents looping error if fallback also fails
                        e.target.src = `${baseURL}/images/default-makers.jpeg`; // Fallback image
                    }}
                />
            </React.Fragment>
        );
    };

    const createdDateAndTimeBodyTemplate = (rowData) => {
        const isoDate = rowData?.createdDate;
        const date = new Date(isoDate);

        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");

        let ampm = "AM";
        if (hours >= 12) {
            ampm = "PM";
            hours -= 12;
        }
        if (hours === 0) {
            hours = 12;
        }

        const formattedDateTime = `${dd}/${mm}/${yyyy} ${hours}:${minutes} ${ampm}`;
        return <p>{formattedDateTime}</p>;
    };
    const headerText = currentModal === "Add" ? "Add Maker" : isEditable === true ? "Edit Maker" : "View Maker";
    const header = <span className="title-border">{headerText}</span>;

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Dialog resizable={false} header={header} visible={displayDialog} maskClassName="zindex8888" blockScroll style={{ width: "40vw" }} onHide={() => onHide()} draggable={false}>
                        {currentModal === "Add" ? <AddCompany onHide={onHide} getMakerList={getMakerList} /> : currentModal === "EditView" && <EditViewCompany onHide={onHide} makerdataId={makerdataId} getMakerList={getMakerList} isEditable={isEditable} />}
                    </Dialog>
                    <div>
                        <Modal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleDeleteMaker} rowData={modalData} loadingBtn={loadingBtn} type="delete" headerText="Are you sure you want to delete this Maker?" />
                    </div>{" "}
                    <div>
                        <Modal
                            isOpen={switchModal}
                            onClose={handleSwitchModalClose}
                            onConfirm={handleInputSwitch}
                            type="active/inactive"
                            loadingBtn={loadingBtn}
                            rowData={switchData}
                            isActive={switchData?.isActive}
                            headerText={`Are you sure you want to ${switchData?.isActive ? "Inactive" : "Active"} this Maker?`}
                        />
                    </div>
                    <NavigationComponent title={`Maker Management`} addNewHandleDialog={handleDialog} isBackButtonLink={() => history.goBack()} />
                    <div className="card-ml-1 dark-bg">
                        <DataTable
                            header={
                                <div className="flex justify-content-end custom-alignment" style={{ display: "flex", alignItems: "center" }}>
                                    {" "}
                                    <span className="mr-2 font-semibold text-base">Status:</span>
                                    <Dropdown
                                        className=""
                                        style={{ width: "215px" }}
                                        options={statusOptions}
                                        optionLabel="name"
                                        optionValue="id"
                                        value={statusValue}
                                        onChange={(e) => setStatusValue(e.target.value)}
                                        placeholder="Select Status"
                                        itemTemplate={optionTemplate}
                                        valueTemplate={selectedItemTemplate}
                                    />
                                    <span className="p-input-icon-right">
                                        <i className="pi pi-search" />
                                        <InputText className="Input__Round ml-3" placeholder="Search..." value={globalFilterValue} onChange={onGlobalFilterChange} />
                                    </span>
                                </div>
                            }
                            filters={filters}
                            globalFilterFields={["name", "countryId.name"]}
                            responsive={true}
                            responsiveLayout="scroll"
                            stripedRows
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            value={filteredMakers}
                            emptyMessage="No records found"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        >
                            <Column body={ImageTemplate} header="Image" style={{ width: "150px" }} />
                            <Column field="name" header="Maker" style={{ width: "150px" }} />
                            <Column field="countryId.name" header="Country" style={{ width: "150px" }} />
                            <Column body={createdDateAndTimeBodyTemplate} header="Created On" style={{ width: "150px" }} />
                            {!userRole?.toLowerCase().includes("user") && <Column body={statusTemplate} header="Status" style={{ width: "90px" }} />}
                            <Column header="Action" body={actionTemplate} style={{ width: "90px" }} />
                        </DataTable>
                        <Modal />
                    </div>
                </>
            )}
        </>
    );
};

export default ManageCampany;
